export default "__VITE_ASSET__YwzAPYD9__"